import { ContextKindKey } from '@gonfalon/contexts/types';
import { List, Record } from '@gonfalon/immutable-shim/immutableShim';
import { v4 } from 'uuid';

import type { Clause } from '#utils/clause/records/Clause';
import { createClause } from '#utils/clause/records/Clause';

type SegmentRuleProps = {
  _key: string;
  _id: string;
  clauses: List<Clause>;
  weight?: number;
  rolloutContextKind?: string;
  bucketBy?: string;
  description?: string;
};

export class SegmentRule extends Record<SegmentRuleProps>({
  _key: '',
  _id: '',
  clauses: List.of(createClause()),
  weight: undefined,
  rolloutContextKind: ContextKindKey.USER,
  bucketBy: undefined,
  description: '',
}) {
  hasNonUserContextClause() {
    return this.clauses.some((c) => !!c.contextKind && c.contextKind !== ContextKindKey.USER);
  }
  hasNonUserContextRollout() {
    return !!this.rolloutContextKind && this.rolloutContextKind !== ContextKindKey.USER;
  }
  hasNestedSegmentClause() {
    return this.clauses.some((c) => c.hasSegmentOp());
  }
}
export function createSegmentRule(props = {}) {
  const rule = props instanceof SegmentRule ? props : new SegmentRule(props);
  return rule.update('_key', (key) => key || v4()).update('clauses', (cs) => cs.map(createClause));
}
